import apiControlCall from './apiControl'

window.setServerAddres = () => {
	//console.log(location.pathname)
	//console.log(location.protocol)
	//console.log(location.host)
	const directories = location.pathname.split('/')
	console.log(isNaN(Number(directories[2])))
	if(directories.length===3&&!isNaN(Number(directories[2])))
	{
		const society = directories[directories.length-1]
		apiControlCall('server',location.protocol+'/'+location.host+'/'+society)
	}
	else
	{
		apiControlCall('server',location.protocol+'/'+location.host)
	}
}

window.playSE = (seName) => {
	apiControlCall('se',seName)
}
